export const style = {
  addressCard: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'end',
    backgroundColor: 'gray.100',
    paddingX: 7,
    paddingY: 5,
    borderRadius: 10,
    marginBottom: 5,
  },
  // we capitalize everything to ensure it's consistent
  addressText: {
    fontWeight: 'bold',
    textTransform: 'capitalize',
  },
  center: {
    justifyContent: 'center',
    alignItems: 'center',
  },
};
